import {push} from 'connected-react-router';
import {
  RESET,
  GET_SUMMARY_REPORT_REQUEST,
  GET_SUMMARY_REPORT_SUCCESS,
  GET_SUMMARY_REPORT_FAIL,
  GET_DRIVER_REPORT_REQUEST,
  GET_DRIVER_REPORT_SUCCESS,
  GET_DRIVER_REPORT_FAIL,
  GET_DETAILS_REPORT_REQUEST,
  GET_DETAILS_REPORT_SUCCESS,
  GET_DETAILS_REPORT_FAIL,
  DOWNLOAD_REPORT_REQUEST,
  DOWNLOAD_REPORT_SUCCESS,
  DOWNLOAD_REPORT_FAIL
} from './ReportActionsType';
import ReportService from './service/ReportService';

export const loadSummaryReport = params => async dispatch => {
  dispatch({type: GET_SUMMARY_REPORT_REQUEST, payload: params});
  try {
    const report = await ReportService.loadSummaryReport(params);
    dispatch({type: GET_SUMMARY_REPORT_SUCCESS, payload: {report, params}});
  } catch (e) {
    console.error('Unable to get summary report', e);
    dispatch({type: GET_SUMMARY_REPORT_FAIL});
  }
};

export const loadDriverReport = params => async dispatch => {
  dispatch({type: GET_DRIVER_REPORT_REQUEST, payload: params});
  try {
    const report = await ReportService.loadSummaryDriverReport(params);
    dispatch({type: GET_DRIVER_REPORT_SUCCESS, payload: {report, params}});
  } catch (e) {
    console.error('Unable to get driver report', e);
    dispatch({type: GET_DRIVER_REPORT_FAIL});
  }
};

export const loadDetailsReport = params => async dispatch => {
  dispatch({type: GET_DETAILS_REPORT_REQUEST, payload: params});
  try {
    const report = await ReportService.loadSummaryDetailsReport(params);
    dispatch({type: GET_DETAILS_REPORT_SUCCESS, payload: {report, params}});
  } catch (e) {
    console.error('Unable to get details report', e);
    dispatch({type: GET_DETAILS_REPORT_FAIL});
  }
};

export const downloadReport = (reportType, params) => async dispatch => {
  dispatch({type: DOWNLOAD_REPORT_REQUEST, payload: params});

  try {
    const report = await ReportService.downloadReport(reportType, params);
    dispatch({type: DOWNLOAD_REPORT_SUCCESS, payload: {report, params}});

    return report;
  } catch (e) {
    console.error(`Unable to download report ${reportType.name}`, e);
    dispatch({type: DOWNLOAD_REPORT_FAIL});
  }
};

export const reset = () => dispatch => dispatch({type: RESET});
export const goToPlayer = mediaId => dispatch => dispatch(push(`/player?mediaId=${mediaId}&camera=split-camera`));
